<template>
  <div>
    <organism-dashboard
      :statusCountList="statusCountList"
      :isLoadingTicketPriority="isLoadingTicketPriority"
      :ticketPriorityCount="ticketPriorityCount"
      :ticketPriorityList="ticketPriorityList"
      :isLoadingNewEntry="isLoadingNewEntry"
      :newEntryList="newEntryList"
      :isLoadingTicketEscalation="isLoadingTicketEscalation"
      :ticketEscalationList="ticketEscalationList"
      :isLoadingRecentChange="isLoadingRecentChange"
      :recentChangeList="recentChangeList"
      :isLoadingEntryStat="isLoadingEntryStat"
      :entryStat="entryStat"
      :isLoadingIdc="isLoadingIdc"
      :idcData="idcData"
      @changeEntryStatTime="changeEntryStatTime"
      @changeIdcType="getIdc"
    ></organism-dashboard>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { DateTime } from "luxon"
import mixinsDateTime from "@/mixins/mixinsDatetime"
import mixinsSiteHelper from "@/mixins/mixinsSiteHelper"
import OrganismDashboard from "@/components/organisms/portal/internal/dashboard/OrganismDashboard.vue"
import * as dashboardApi from "@/api/api-module1-dashboard"
import axios from "axios"
import { TicketType, DateTimeFormat } from "@/constants"

export default {
  name: "PortalDashboard",
  components: { OrganismDashboard },
  mixins: [mixinsDateTime, mixinsSiteHelper],
  data() {
    return {
      // STATUS COUNT
      statusCountList: [
        {
          name: "ticket",
          open: 0,
          inProgress: 0,
          isLoading: true,
        },
        {
          name: "access",
          waiting: 0,
          approved: 0,
          isLoading: true,
        },
        // {
        //   name: "smartHand",
        //   waiting: 0,
        //   inProgress: 0,
        //   isLoading: true,
        // },
        // {
        //   name: "parcel",
        //   waiting: 0,
        //   received: 0,
        //   isLoading: true,
        // },
        // {
        //   name: "xConnect",
        //   waiting: 0,
        //   inProgress: 0,
        //   isLoading: true,
        // },
        {
          name: "contract",
          waiting: 0,
          isLoading: true,
        },
      ],

      // TICKET TRACKING PRIORITY
      isLoadingTicketPriority: true,
      ticketPriorityCount: 0,
      ticketPriorityList: [
        {
          name: "Critical",
          value: 0,
          color: "#584CDB",
        },
        {
          name: "High",
          value: 0,
          color: "#9087F3",
        },
        {
          name: "Medium",
          value: 0,
          color: "#B6B0F7",
        },
        {
          name: "Low",
          value: 0,
          color: "#E3E1FC",
        },
      ],

      // INVENTORY MA DATE
      // isLoadingInventory: true,
      // inventoryList: {
      //   item: [],
      //   count: {
      //     all: 0,
      //     expireSoon: 0,
      //     expired: 0,
      //   },
      // },

      // NEW ENTRY
      isLoadingNewEntry: true,
      newEntryList: new Map(),

      // TICKET ESCALATION
      isLoadingTicketEscalation: true,
      ticketEscalationList: [],

      // RECENT CHANGE
      isLoadingRecentChange: true,
      recentChangeList: new Map(),

      // NEW ENTRY STATISTICS
      latestSelectedStatPeriod: {
        startDate: null,
        endDate: null,
      },
      isLoadingEntryStat: true,
      entryStat: {
        timestampList: [],
        dateList: [],
      },

      // IDC DATABASE
      isLoadingIdc: true,
      currentContractType: "recent",
      idcData: {
        fields: [
          {
            field: "id",
            label: "ID",
          },
          {
            field: "customer",
            label: "CUSTOMER NAME",
          },
          {
            field: "packages",
            label: "PACKAGES",
          },
          {
            field: "site",
            label: "SITE",
          },
          {
            field: "status",
            label: "STATUS",
          },
          {
            field: "saleContact",
            label: "SALE CONTACT",
          },
        ],
        recentList: [],
        waitingList: [],
      },
      intervalId: 0,
    }
  },
  computed: {
    ...mapGetters("appAutoRefresh", ["getWPMDashboardAutoRefresh"]),

    ...mapGetters("siteStore", ["siteSetting", "siteOptions"]),

    isEnableAutoRefresh() {
      return this.getWPMDashboardAutoRefresh
    },
  },

  watch: {
    async siteSetting() {
      await this.fetchData()
    },

    isEnableAutoRefresh: {
      deep: true,
      immediate: true,
      handler() {
        if (this.isEnableAutoRefresh) {
          this.intervalId = window.setInterval(() => {
            this.setIsLoadingAllTrue()
            this.fetchData()
          }, 60000)
        } else {
          window.clearInterval(this.intervalId)
        }
      },
    },
  },

  async mounted() {
    this.latestSelectedStatPeriod.startDate = DateTime.now()
      .minus({ months: 1 })
      .toISO()
    this.latestSelectedStatPeriod.endDate = DateTime.now().toISO()
    this.setIsShowAutoRefresh(true)
    await this.fetchData()
  },
  beforeDestroy() {
    this.setIsShowAutoRefresh(false)
    window.clearInterval(this.intervalId)
  },

  methods: {
    ...mapActions("appAutoRefresh", ["setIsShowAutoRefresh"]),

    async fetchData() {
      this.setIsLoadingAllTrue()
      await axios.all([
        this.getStatusCount(),
        this.getTicketPriority(),
        // this.getInventory(),
        this.getTicketEscalation(),
        this.getNewEntry(),
        this.getRecentChange(),
        this.getEntryStat(),
        this.getIdc(this.currentContractType),
      ])
    },

    getStatusCount() {
      this.getStatTicket()
      this.getStatSiteAccess()
      // this.getStatSmartHand()
      // this.getStatParcel()
      // this.getStatXConnect()
      this.getStatContract()
    },

    async getStatTicket() {
      const filterData = this.filterDecoration()
      await dashboardApi.getStatTicket(filterData).then((response) => {
        this.statusCountList.forEach((item) => {
          if (item.name === "ticket") {
            const openedList = response.data.stats.find(
              (item) => item.name === "OPENED"
            )
            const inProgressList = response.data.stats.find(
              (item) => item.name === "IN_PROGRESS"
            )

            item.open = openedList ? openedList.count : 0
            item.inProgress = inProgressList ? inProgressList.count : 0
            item.isLoading = false
          }
        })
      })
    },

    async getStatSiteAccess() {
      const filterData = this.filterDecoration()
      await dashboardApi.getStatSiteAccess(filterData).then((response) => {
        this.statusCountList.forEach((item) => {
          if (item.name === "access") {
            const waitingList = response.data.stats.find(
              (item) => item.name === "WAITING"
            )
            const approvedList = response.data.stats.find(
              (item) => item.name === "APPROVED"
            )

            item.waiting = waitingList ? waitingList.count : 0
            item.approved = approvedList ? approvedList.count : 0
            item.isLoading = false
          }
        })
      })
    },

    // async getStatSmartHand() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi.getStatSmartHand(filterData).then((response) => {
    //     this.statusCountList.forEach((item) => {
    //       if (item.name === "smartHand") {
    //         const waitingList = response.data.stats.find(
    //           (item) => item.name === "WAITING"
    //         )
    //         const inProgressList = response.data.stats.find(
    //           (item) => item.name === "IN_PROGRESS"
    //         )

    //         item.waiting = waitingList ? waitingList.count : 0
    //         item.inProgress = inProgressList ? inProgressList.count : 0
    //         item.isLoading = false
    //       }
    //     })
    //   })
    // },

    // async getStatParcel() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi.getStatParcel(filterData).then((response) => {
    //     this.statusCountList.forEach((item) => {
    //       if (item.name === "parcel") {
    //         const waitingList = response.data.stats.find(
    //           (item) => item.name === "WAITING"
    //         )
    //         const receivedList = response.data.stats.find(
    //           (item) => item.name === "RECEIVED"
    //         )

    //         item.waiting = waitingList ? waitingList.count : 0
    //         item.inProgress = receivedList ? receivedList.count : 0
    //         item.isLoading = false
    //       }
    //     })
    //   })
    // },

    // async getStatXConnect() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi.getStatXConnect(filterData).then((response) => {
    //     this.statusCountList.forEach((item) => {
    //       if (item.name === "xConnect") {
    //         const waitingList = response.data.stats.find(
    //           (item) => item.name === "WAITING"
    //         )
    //         const inProgressList = response.data.stats.find(
    //           (item) => item.name === "IN_PROGRESS"
    //         )
    //         item.waiting = waitingList ? waitingList.count : 0
    //         item.inProgress = inProgressList ? inProgressList.count : 0
    //         item.isLoading = false
    //       }
    //     })
    //   })
    // },

    async getStatContract() {
      const filterData = this.filterDecoration()
      await dashboardApi
        .getStatContract({ status: "PENDING", ...filterData })
        .then((response) => {
          this.statusCountList.forEach((item) => {
            if (item.name === "contract") {
              const waitingList = response.data.stats.find(
                (item) => item.name === "PENDING"
              )
              item.waiting = waitingList ? waitingList.count : 0
              item.isLoading = false
            }
          })
        })
    },

    async getTicketPriority() {
      const filterData = this.filterDecoration()
      await dashboardApi
        .getStatTicket({
          groupBy: "priority",
          Status: ["OPENED", "IN_PROGRESS"],
          ...filterData,
        })
        .then(({ data }) => {
          this.ticketPriorityCount = data.total
          data.stats.forEach(({ name, count }) => {
            if (name === "CRITICAL") {
              this.ticketPriorityList[0].value = count || 0
            } else if (name === "HIGH") {
              this.ticketPriorityList[1].value = count || 0
            } else if (name === "MEDIUM") {
              this.ticketPriorityList[2].value = count || 0
            } else if (name === "LOW") {
              this.ticketPriorityList[3].value = count || 0
            }
          })
        })
        .finally(() => {
          this.isLoadingTicketPriority = false
        })
    },

    // async getInventory() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi
    //     .getMaDate(filterData)
    //     .then((response) => {
    //       if (response) {
    //         this.inventoryList.item = response.data
    //           .map(({ name, type, status, maLastDate, siteName }) => {
    //             return {
    //               name,
    //               type,
    //               status,
    //               siteName,
    //               maLastDate: maLastDate
    //                 ? this.setDateTimeFormat(maLastDate, "dd/MM/yyyy")
    //                 : null,
    //             }
    //           })
    //           .filter(
    //             (item) =>
    //               item.status === "EXPIRED" || item.status === "EXPIRE_SOON"
    //           )
    //         this.inventoryList.count = {
    //           all: response.statistics?.all || 0,
    //           expireSoon: response.statistics?.expireSoon || 0,
    //           expired: response.statistics?.expired || 0,
    //         }
    //       }
    //     })
    //     .finally(() => {
    //       this.isLoadingInventory = false
    //     })
    // },

    async getNewEntryTicket() {
      const filterData = this.filterDecoration()
      await dashboardApi
        .getNewEntryTicket(filterData)
        .then((response) => {
          const data = response.data.map((item) => {
            return {
              id: item.ticketId,
              idLabel: `${this.getTicketType(item.ticketType)} ${
                item.ticketId
              }`,
              companyName: item.contractCustomerName,
              idcId: item.contractId?.toString().padStart(8, "0"),
              subject: item.ticketSubject,
              detail: item.ticketDetail,
              date: this.setDateTimeFormat(item.openedAt, "dd/MM/yyyy"),
              time: this.setDateTimeFormat(item.openedAt, "HH:mm:ss"),
              priority: item.priority,
              siteName: item?.siteName,
            }
          })

          this.newEntryList.set("ticket", data)
        })
        .catch(() => this.newEntryList.set("ticket", []))
    },

    getTicketType(ticketType) {
      switch (ticketType) {
        case TicketType.NORMAL:
          return "Ticket"
        case TicketType.INCIDENT:
          return "Incident"
        case TicketType.JOB:
          return "Job"
        default:
          return ticketType
      }
    },

    async getNewEntrySiteAccess() {
      const filterData = this.filterDecoration()
      await dashboardApi
        .getNewEntrySiteAccess(filterData)
        .then((response) => {
          const data = response.data.map((item) => {
            return {
              id: item.siteAccessId,
              companyName: item.contractCustomerName,
              idcId: item.contractId?.toString().padStart(8, "0"),
              detail: item.description,
              visitors: item.visitors.map((visitor) => visitor.fullName),
              date: this.setDateTimeFormat(item.createdAt, "dd/MM/yyyy"),
              time: this.setDateTimeFormat(item.createdAt, "HH:mm:ss"),
              siteName: item?.siteName,
            }
          })

          this.newEntryList.set("access", data)
        })
        .catch(() => this.newEntryList.set("access", []))
    },

    // async getNewEntrySmartHand() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi
    //     .getNewEntrySmartHand(filterData)
    //     .then((response) => {
    //       const data = response.data.map((item) => {
    //         return {
    //           id: item.smartHandId,
    //           companyName: item.contractCustomerName,
    //           idcId: item.contractId?.toString().padStart(8, "0"),
    //           jobTitle: item.title,
    //           detail: item.description,
    //           date: this.setDateTimeFormat(item.createdAt, "dd/MM/yyyy"),
    //           time: this.setDateTimeFormat(item.createdAt, "HH:mm:ss"),
    //           siteName: item?.siteName,
    //         }
    //       })

    //       this.newEntryList.set("smartHand", data)
    //     })
    //     .catch(() => this.newEntryList.set("smartHand", []))
    // },

    // async getNewEntryParcel() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi
    //     .getNewEntryParcel(filterData)
    //     .then((response) => {
    //       const data = response.data.map((item) => {
    //         return {
    //           id: item.trackingId,
    //           companyName: item.contractCustomerName,
    //           idcId: item.contractId?.toString().padStart(8, "0"),
    //           totalParcel: item.totalParcel,
    //           sentDate: item.registeredDate
    //             ? this.setDateTimeFormat(
    //                 item.registeredDate,
    //                 "dd/MM/yyyy HH:mm"
    //               )
    //             : "-",
    //           date: this.setDateTimeFormat(item.createdAt, "dd/MM/yyyy"),
    //           time: this.setDateTimeFormat(item.createdAt, "HH:mm:ss"),
    //           siteName: item?.siteName,
    //         }
    //       })

    //       this.newEntryList.set("parcel", data)
    //     })
    //     .catch(() => this.newEntryList.set("parcel", []))
    // },

    // async getNewEntryXConnect() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi
    //     .getNewEntryXConnect(filterData)
    //     .then((response) => {
    //       const data = response.data.map((item) => {
    //         return {
    //           id: item.crossConnectId,
    //           companyName: item.contractCustomerName,
    //           idcId: item.contractId?.toString().padStart(8, "0"),
    //           origin: item.origin,
    //           destination: item.destination,
    //           date: this.setDateTimeFormat(item.createdAt, "dd/MM/yyyy"),
    //           time: this.setDateTimeFormat(item.createdAt, "HH:mm:ss"),
    //           siteName: item?.siteName,
    //         }
    //       })

    //       this.newEntryList.set("xConnect", data)
    //     })
    //     .catch(() => this.newEntryList.set("xConnect", []))
    // },

    async getNewEntry() {
      await axios
        .all([
          this.getNewEntryTicket(),
          this.getNewEntrySiteAccess(),
          // this.getNewEntrySmartHand(),
          // this.getNewEntryParcel(),
          // this.getNewEntryXConnect(),
        ])
        .then(() => {
          this.isLoadingNewEntry = false
        })
    },

    async getRecentEntryTicket() {
      const filterData = this.filterDecoration()
      await dashboardApi
        .getRecentEntryTicket(filterData)
        .then((response) => {
          const data = response.data.map((item) => {
            return {
              id: item.ticketId,
              idLabel: `${this.getTicketType(item.ticketType)} ${
                item.ticketId
              }`,
              companyName: item.contractCustomerName,
              idcId: item.contractId?.toString().padStart(8, "0"),
              subject: item.subject,
              staff: item.lastThreadActor,
              activity: item.message,
              status: item.status,
              priority: item.priority,
              date: item.updatedAt
                ? this.setDateTimeFormat(item.updatedAt, "dd/MM/yyyy")
                : "-",
              time: item.updatedAt
                ? this.setDateTimeFormat(item.updatedAt, "HH:mm:ss")
                : "-",
              siteName: item?.siteName,
            }
          })

          this.recentChangeList.set("ticket", data)
        })
        .catch(() => this.recentChangeList.set("ticket", []))
    },

    async getRecentEntrySiteAccess() {
      const filterData = this.filterDecoration()
      await dashboardApi
        .getRecentEntrySiteAccess(filterData)
        .then((response) => {
          const data = response.data.map((item) => {
            return {
              id: item.siteAccessId,
              companyName: item.contractCustomerName,
              idcId: item.contractId?.toString().padStart(8, "0"),
              idcCard: item.idcCard,
              // in: item.checkIn
              //   ? this.setDateTimeFormat(
              //       item.checkIn,
              //       DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
              //     )
              //   : "-",
              // out: item.checkout
              //   ? this.setDateTimeFormat(
              //       item.checkout,
              //       DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
              //     )
              //   : "-",
              status: item.status,
              date: item.updatedAt
                ? this.setDateTimeFormat(item.updatedAt, "dd/MM/yyyy")
                : "-",
              time: item.updatedAt
                ? this.setDateTimeFormat(item.updatedAt, "HH:mm:ss")
                : "-",
              siteName: item?.siteName,
              visitors: item.visitors.map((visitor) => visitor.fullName),
              firstCheckIn: this.setDateTimeFormat(
                item.firstCheckIn,
                DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
              ),
              lastCheckout: this.setDateTimeFormat(
                item.lastCheckout,
                DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
              ),
            }
          })

          this.recentChangeList.set("access", data)
        })
        .catch(() => this.recentChangeList.set("access", []))
    },

    // async getRecentEntrySmartHand() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi
    //     .getRecentEntrySmartHand(filterData)
    //     .then((response) => {
    //       const data = response.data.map((item) => {
    //         return {
    //           id: item.smartHandId,
    //           companyName: item.contractCustomerName,
    //           idcId: item.contractId?.toString().padStart(8, "0"),
    //           jobTitle: item.subject,
    //           department: item.lastThreadActor,
    //           activity: item.message,
    //           status: item.status,
    //           date: this.setDateTimeFormat(item.updatedAt, "dd/MM/yyyy"),
    //           time: this.setDateTimeFormat(item.updatedAt, "HH:mm:ss"),
    //           siteName: item?.siteName,
    //         }
    //       })

    //       this.recentChangeList.set("smartHand", data)
    //     })
    //     .catch(() => this.recentChangeList.set("smartHand", []))
    // },

    // async getRecentEntryParcel() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi
    //     .getRecentEntryParcel(filterData)
    //     .then((response) => {
    //       const data = response.data.map((item) => {
    //         return {
    //           id: item.parcelId,
    //           companyName: item.contractCustomerName,
    //           idcId: item.contractId?.toString().padStart(8, "0"),
    //           totalParcel: item.parcelItems,
    //           receivedBy: item.receivedBy,
    //           receiveDate: item.receivedDate
    //             ? this.setDateTimeFormat(
    //                 item.receivedDate,
    //                 DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
    //               )
    //             : "-",
    //           status: item.status,
    //           date: this.setDateTimeFormat(item.updatedAt, "dd/MM/yyyy"),
    //           time: this.setDateTimeFormat(item.updatedAt, "HH:mm:ss"),
    //           siteName: item?.siteName,
    //         }
    //       })

    //       this.recentChangeList.set("parcel", data)
    //     })
    //     .catch(() => this.recentChangeList.set("parcel", []))
    // },

    // async getRecentEntryXConnect() {
    //   const filterData = this.filterDecoration()
    //   await dashboardApi
    //     .getRecentEntryXConnect(filterData)
    //     .then((response) => {
    //       const data = response.data.map((item) => {
    //         return {
    //           id: item.crossConnectId,
    //           companyName: item.contractCustomerName,
    //           idcId: item.contractId?.toString().padStart(8, "0"),
    //           staff: item.customerName,
    //           activity: item.message,
    //           origin: item.origin,
    //           destination: item.destination,
    //           status: item.status,
    //           date: this.setDateTimeFormat(item.updatedAt, "dd/MM/yyyy"),
    //           time: this.setDateTimeFormat(item.updatedAt, "HH:mm:ss"),
    //           siteName: item?.siteName,
    //         }
    //       })

    //       this.recentChangeList.set("xConnect", data)
    //     })
    //     .catch(() => this.recentChangeList.set("xConnect", []))
    // },

    async getTicketEscalation() {
      const filterData = this.filterDecoration()
      await dashboardApi
        .getRecentEntryEscalation(filterData)
        .then((response) => {
          this.ticketEscalationList = response.data.map((item) => ({
            id: item.ticketId,
            idLabel: `${this.getTicketType(item.ticketType)} ${item.ticketId}`,
            companyName: item.customerName,
            idcId: item.idcId?.toString().padStart(8, "0"),
            subject: item.subject,
            lastReply: item.lastReply,
            level: item.level,
            escalateBy: item.escalateBy,
            current: item.currentResponsiblePerson,
            status: item.status,
            date: this.setDateTimeFormat(item.escalateTime, "dd/MM/yyyy"),
            time: this.setDateTimeFormat(item.escalateTime, "HH:mm:ss"),
            isUserLevel: item.isUserLevel,
            siteName: item?.siteName,
          }))
        })
        .finally(() => {
          this.isLoadingTicketEscalation = false
        })
    },

    async getRecentChange() {
      await axios
        .all([
          this.getRecentEntryTicket(),
          this.getRecentEntrySiteAccess(),
          // this.getRecentEntrySmartHand(),
          // this.getRecentEntryParcel(),
          // this.getRecentEntryXConnect(),
        ])
        .then(() => {
          this.isLoadingRecentChange = false
        })
    },

    async getEntryStat() {
      this.entryStat.timestampList = []
      this.entryStat.dataList = [
        {
          key: "ticket_tracking",
          name: "Ticket Tracking",
          color: "#7367F0",
          itemColor: "#B6AFF4",
          data: [],
        },
        {
          key: "site_access",
          name: "Site Access",
          color: "#1ABC9C",
          itemColor: "#89DACA",
          data: [],
        },
        {
          key: "contract",
          name: "Contract",
          color: "#005DE8",
          itemColor: "#7CAAF0",
          data: [],
        },
        // {
        //   key: "smart_hand",
        //   name: "Smart Hand ",
        //   color: "#FF9F43",
        //   itemColor: "#FCCB9E",
        //   data: [],
        // },
        // {
        //   key: "parcel_tracking",
        //   name: "Parcel Tracking",
        //   color: "#1ABCFE",
        //   itemColor: "#89DAFB",
        //   data: [],
        // },

        // {
        //   key: "cross_connect",
        //   name: "XConnect",
        //   color: "#EA5455",
        //   itemColor: "#F1A6A7",
        //   data: [],
        // },
      ]

      const filterData = this.filterDecoration()
      const params = {
        StartDate: this.removeTimeZone(
          this.latestSelectedStatPeriod?.startDate
        ),
        EndDate: this.removeTimeZone(this.latestSelectedStatPeriod?.endDate),
        ...filterData,
      }
      await dashboardApi
        .getNewEntryStat(params)
        .then((response) => {
          this.entryStat.timestampList = response.site_access.map((item) =>
            this.setDateTimeFormat(
              item.timestamp,
              DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
            )
          )

          // ticket_tracking
          this.entryStat.dataList[0].data = response.ticket_tracking.map(
            (item) => item.value
          )

          // site_access
          this.entryStat.dataList[1].data = response.site_access.map(
            (item) => item.value
          )

          // contract
          this.entryStat.dataList[2].data = response.contract.map(
            (item) => item.value
          )

          // smart_hand
          // this.entryStat.dataList[1].data = response.smart_hand.map(
          //   (item) => item.value
          // )

          // parcel_tracking
          // this.entryStat.dataList[2].data = response.parcel_tracking.map(
          //   (item) => item.value
          // )

          // cross_connect
          // this.entryStat.dataList[4].data = response.cross_connect.map(
          //   (item) => item.value
          // )
        })
        .finally(() => {
          this.isLoadingEntryStat = false
        })
    },

    changeEntryStatTime(selectedPeriod) {
      // prevent api called when have only different in second and millisecond
      const previousStartDate = this.setDateTimeFormat(
        selectedPeriod.startDate,
        DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
      )
      const currentStartDate = this.setDateTimeFormat(
        this.latestSelectedStatPeriod.startDate,
        DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
      )
      const previousEndDate = this.setDateTimeFormat(
        selectedPeriod.endDate,
        DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
      )
      const currentEndDate = this.setDateTimeFormat(
        this.latestSelectedStatPeriod.endDate,
        DateTimeFormat.DATETIME_NUMBER_WITHOUT_SEC
      )

      if (
        previousStartDate !== currentStartDate ||
        previousEndDate !== currentEndDate
      ) {
        this.latestSelectedStatPeriod.startDate = selectedPeriod.startDate
        this.latestSelectedStatPeriod.endDate = selectedPeriod.endDate
        this.isLoadingEntryStat = true
        this.getEntryStat()
      }
    },

    async getIdc(type) {
      this.currentContractType = type
      this.idcData.recentList = []
      this.idcData.waitingList = []
      const filterData = this.filterDecoration()
      const limit = type === "recent" ? 10 : -1
      this.isLoadingIdc = true
      await dashboardApi
        .getIdcDatabase({ type, limit, ...filterData })
        .then((response) => {
          const contractData = response.data.map((contract) => {
            return {
              id: contract.idcId.toString().padStart(8, "0"),
              additionalIds: contract.additionalIds,
              customer: {
                customerName: contract.customer.customerName,
                organizationName: contract.customer.customerOrganizationName,
              },
              package: contract.packages.map((item) => ({
                packageName: item.packageName,
                service: item.serviceName,
                domain: item.domain,
                rack: item?.oceanRacks,
                locationName: item.locationName,
              })),
              site: contract.siteName,
              status: this.getContractStatus(contract.status),
              saleContact: {
                name: contract.saleContact.contactName || "-",
                phone: contract.saleContact.contactEmail,
                email: contract.saleContact.contactPhone,
              },
            }
          })

          if (type === "recent") {
            this.idcData.recentList = contractData
          } else if (type === "waiting") {
            this.idcData.waitingList = contractData
          }
        })
        .finally(() => {
          this.isLoadingIdc = false
        })
    },

    getContractStatus(status) {
      const statusOption = [
        { id: 1, name: "Approved" },
        { id: 2, name: "Deleted" },
        { id: 3, name: "Pending" },
        { id: 4, name: "Expired" },
        { id: 5, name: "Suspended" },
      ]
      return (
        statusOption.find(
          (item) => item.name.toLowerCase() === status.toLowerCase()
        ) || { id: 0, name: "" }
      )
    },

    filterDecoration() {
      return { SiteIds: this.siteOptions.map((site) => site.value) }
    },

    setIsLoadingAllTrue() {
      this.statusCountList.forEach((item) => {
        item.isLoading = true
      })

      this.isLoadingTicketPriority = true
      this.isLoadingTicketEscalation = true
      this.isLoadingNewEntry = true
      this.isLoadingRecentChange = true
      this.isLoadingEntryStat = true
      this.isLoadingIdc = true
      // this.isLoadingInventory = true
      // this.isLoadingRemaining = true
    },
  },
}
</script>

<style lang="scss" scoped></style>
